import React from 'react';
import PropTypes from 'prop-types';

import { Button as Btn } from 'semantic-ui-react';

import './Button.css';


const Button = ({
  children,
  onClick,
  disabled,
  className,
  borderedBlue,
  loading,
  small,
}) => {
  const calculateClassName = () => { 
    let value = 'button__component';
    if (className) { value += ` ${className}`; }
    if (borderedBlue) { value += ' bordered-blue'; }
    if (small) { value += ' small'; }
    return value;
  };

  return (
    <Btn
      className={calculateClassName()}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
    >
      {children}
    </Btn>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  borderedBlue: PropTypes.string,
  loading: PropTypes.bool,
  small: PropTypes.bool,
};

Button.defaultProps = {
  onClick: null,
  disabled: null,
  className: null,
  borderedBlue: null,
  loading: false,
  small: null,
};

export default Button;
